import { createReducer } from 'deox';
import {
  Entity,
  AppsInfo,
  Categories,
  Paging,
  AssetsSocial,
  ComplianceLevel,
  UserSocial,
  Articles,
  Article,
  DocOverview,
  Category,
} from '@/types';
import {
  fetchEntityActions,
  fetchEntityByIdActions,
  fetchAppsInfoActions,
  fetchCategoriesActions,
  fetchListEntityActions,
  fetchAssetSocialActions,
  deleteEntityActions,
  fetchComplianceLevelsActions,
  fetchListUserSocialActions,
  fetchArticlesActions,
  fetchArticlesBySlugActions,
  fetchDocsOverviewActions,
  fetchCategoryByIdActions,
  loadMoreArticlesActions,
} from '../actions/service-directory';
import { toggleEntityEnabledActions } from '../actions';

export interface ServiceDirectoryState {
  organisation?: Entity;
  appsInfo?: AppsInfo;
  assetsSocial?: AssetsSocial;
  category?: Category;
  categories?: Categories;
  listEntity: {
    data: Entity[];
    paging: Paging;
  };
  article?: Article;
  articles: {
    data: Articles;
    paging: Paging;
  };
  listUserSocial: {
    data: UserSocial[];
    paging: Paging;
  };
  complianceLevels: ComplianceLevel[];
  docsOverview: DocOverview[];
}

const initialState: ServiceDirectoryState = {
  organisation: undefined,
  article: undefined,
  appsInfo: undefined,
  assetsSocial: undefined,
  category: undefined,
  categories: undefined,
  listEntity: {
    data: [],
    paging: {
      pageNumber: 1,
      pageSize: 0,
      totalRecords: 0,
    },
  },
  articles: {
    data: [],
    paging: {
      pageNumber: 1,
      pageSize: 0,
      totalRecords: 0,
    },
  },
  listUserSocial: {
    data: [],
    paging: {
      pageNumber: 1,
      pageSize: 10,
      totalRecords: 0,
    },
  },
  complianceLevels: [],
  docsOverview: [],
};

const serviceDirectoryReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchEntityActions.success, (state, { payload }) => ({
    ...state,
    organisation: payload,
  })),
  handleAction(fetchEntityByIdActions.success, (state, { payload }) => ({
    ...state,
    organisation: payload,
  })),
  handleAction(fetchListEntityActions.success, (state, { payload }) => {
    return {
      ...state,
      listEntity: payload,
    };
  }),
  handleAction(fetchListUserSocialActions.success, (state, { payload }) => {
    return {
      ...state,
      listUserSocial: payload,
    };
  }),
  handleAction(fetchAppsInfoActions.success, (state, { payload }) => ({
    ...state,
    appsInfo: payload,
  })),
  handleAction(fetchArticlesActions.success, (state, { payload }) => ({
    ...state,
    articles: payload,
  })),
  handleAction(loadMoreArticlesActions.success, (state, { payload }) => {
    const { data, paging } = payload;
    const newData = state.articles.data ? [...state.articles.data, ...data] : data;
    const newPayload = {
      data: newData,
      paging,
    };
    return {
      ...state,
      articles: newPayload,
    };
  }),
  handleAction(fetchArticlesBySlugActions.success, (state, { payload }) => ({
    ...state,
    article: payload,
  })),
  handleAction(fetchCategoryByIdActions.success, (state, { payload }) => ({
    ...state,
    category: payload,
  })),
  handleAction(fetchCategoriesActions.request, (state) => ({
    ...state,
    categories: undefined,
  })),
  handleAction(fetchCategoriesActions.success, (state, { payload }) => ({
    ...state,
    categories: payload,
  })),
  handleAction(fetchAssetSocialActions.success, (state, { payload }) => ({
    ...state,
    assetsSocial: payload,
  })),
  handleAction(deleteEntityActions.success, (state, { payload }) => ({
    ...state,
    listEntity: {
      ...state.listEntity,
      data: state.listEntity.data.filter((e) => e.id !== payload.entityId),
    },
  })),
  handleAction(fetchComplianceLevelsActions.success, (state, { payload }) => ({
    ...state,
    complianceLevels: payload.data,
  })),
  handleAction(fetchDocsOverviewActions.success, (state, { payload }) => ({
    ...state,
    docsOverview: payload.data,
  })),
  handleAction(toggleEntityEnabledActions.success, (state, { payload }) => ({
    ...state,
    organisation: state.organisation
      ? {
          ...state.organisation,
          isActive: payload.isActive,
        }
      : undefined,
  })),
]);

export default serviceDirectoryReducer;
